// Lib
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

// Actions
import { toggleDebugTool } from './debugActions';
import { isDebugToolbarToolEnabled } from './debugStateSelector';

// Styles
import './DebugTool.scss';

export const DebugContext = React.createContext({
    toolName: '',
    toolEnabled: false,
    forceRender: 0,
});

const DebugTool = (props) => {
    const { toolName, children, onClick } = props;

    const toolEnabled = useSelector(isDebugToolbarToolEnabled(toolName));

    const setForcedRender = React.useState(0)[1];

    const forceRender = () => setForcedRender(Date.now());

    const classes = classNames('DebugTool', {
        active: toolEnabled,
    });

    const contextValue = {
        toolName,
        toolEnabled,
        forceRender,
    };

    const dispatch = useDispatch();

    const onClickHandler = useCallback(() => {
        const enabled = !toolEnabled;
        onClick?.(enabled);
        dispatch(
            toggleDebugTool({
                enabled,
                toolName,
            }),
        );
    }, [toolEnabled]);

    return (
        <DebugContext.Provider value={contextValue}>
            <div className={classes} onClick={onClickHandler}>
                {children}
            </div>
        </DebugContext.Provider>
    );
};

DebugTool.propTypes = {
    toolName: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

    toolEnabled: PropTypes.bool,
    toggleDebugTool: PropTypes.func,

    onClick: PropTypes.func,
};

export default DebugTool;
